import { useApi } from './use-api-call';
import { UserDTO } from './user-api';


export const useSearchUserLogApi = () => useApi<{ 
userLogs: UserLogDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/user-log/search-user-log');

export const useGetUserLogApi = () => useApi<{ userLog: UserLogDTO; allowEdit: boolean; }>('/user-log/get-user-log/{serial}');

export const useSaveUserLogApi = () => useApi<{ userLog: UserLogDTO}>('/user-log/save-user-log');

export const useDeleteUserLogApi = () => useApi('/user-log/delete-user-log/{serial}');

export interface UserLogDTO { 
serial?:number;
form:string;
action:string;
message:string;
url:string;
sessionId:number;
userName:string;
isHistoryLog:boolean;
createdAt?:Date;
}
